import React, { Component } from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'

export class Amount extends Component {
    render() {
        return (
            <Div>
                <P>{this.props.amount} {this.props.currency}</P>
            </Div>
        )
    }
}

const Div = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
`

const P = styled.p`
    color: #B3B3B3;
`

const mapStateToProps = (state) => ({
    amount: parseFloat(state.buy.ltc_amount).toFixed(4),
    currency: 'LTC'
})

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(Amount)
